import { render, staticRenderFns } from "./PanelText.vue?vue&type=template&id=247e6b3e&"
import script from "./PanelText.vue?vue&type=script&lang=js&"
export * from "./PanelText.vue?vue&type=script&lang=js&"
import style0 from "./PanelText.vue?vue&type=style&index=0&id=247e6b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports